import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserRoleState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UserRoleState = {
  data: [],
  isLoading: false,
  error: null,
};

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    setUserRoles: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setUserRoleLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUserRoleError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setUserRoles, setUserRoleLoading, setUserRoleError } = userRoleSlice.actions;

export default userRoleSlice.reducer;
